import { memo } from 'react'
import InStockL2Heading from '../Pages/InStockDetailPageV2/InL2Heading'
import { DeepPartial } from 'utility-types'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from 'revamp/reusable-components/tooltip/tooltip'
import { Consensus } from './types'
import { spCopyRight, spCopyRightSource } from './constant'
import WhatExpertsSay from '@/stories/components/USStocksDetail/WhatExpertsSay'
import colors from '@/configs/tailwind/tokens/colors'
import { StencilCDNImage } from '@/components/Common/StencilImage'

const WhatExpertsSayWrapper = memo(
  ({
    consensus = {},
    company_name = '',
  }: {
    consensus: DeepPartial<Consensus> | null
    company_name: string
  }) => {
    let sentimentColor = colors.brand.green.dark
    switch (consensus?.sentiment) {
      case 'HOLD':
        sentimentColor = colors.chart.yellow
        break
      case 'SELL':
        sentimentColor = colors.brand.red.cinnabar
        break
      default:
        break
    }

    const chartBarData: {
      name: string
      color: string
      status: string
      percent: number
    }[] = []

    if (consensus?.buy_per !== undefined) {
      chartBarData.push({
        name: `${consensus.buy_per.toFixed(2)}%`,
        color: colors.brand.green.dark,
        status: 'Buy',
        percent: consensus.buy_per,
      })
    }
    if (consensus?.hold_per !== undefined) {
      chartBarData.push({
        name: `${consensus.hold_per.toFixed(2)}%`,
        color: colors.chart.yellow,
        status: 'Hold',
        percent: consensus.hold_per,
      })
    }
    if (consensus?.sell_per !== undefined) {
      chartBarData.push({
        name: `${consensus.sell_per.toFixed(2)}%`,
        color: colors.brand.red.cinnabar,
        status: 'Sell',
        percent: consensus.sell_per,
      })
    }

    const expertSayTemplate = {
      chartBarData,
      recom: consensus?.sentiment && {
        label: consensus.sentiment,
        bg_color: sentimentColor,
        label_color: '#fff',
      },
      bottom_info: {
        text:
          consensus?.num_analysts && consensus.target_prc
            ? `Based on ${consensus.num_analysts} analysts offering long term price targets for ${company_name}. An average target of ₹${consensus.target_prc}`
            : '',
      },
      footer_text: spCopyRightSource,
    }

    return (
      <div className="flex flex-col justify-start">
        <div className="flex w-full items-center justify-between">
          {company_name && (
            <InStockL2Heading
              heading={`Analysts Recommendation on ${company_name}`}
              subheading={`Get updated buy, sell, and hold recommendations by analysts on ${company_name}.`}
            />
          )}
          <Tooltip>
            <TooltipTrigger>
              <StencilCDNImage
                src="https://indcdn.indmoney.com/public/images/info_new.png"
                width={18}
                height={18}
                onClick={() => {}}
              />
            </TooltipTrigger>
            <TooltipContent>
              <div className="bg-brand-white border-1 shadow-one w-80 p-2 text-xs">
                {spCopyRight}
              </div>
            </TooltipContent>
          </Tooltip>
        </div>
        <p className="text-13px text-brand-grey-base font-normal">
          {`based on ${consensus?.num_analysts} analysts`}
        </p>
        <WhatExpertsSay data={expertSayTemplate} />
      </div>
    )
  },
)

WhatExpertsSayWrapper.displayName = 'WhatExpertsSay'

export default WhatExpertsSayWrapper
